import React from "react";
import "../tracker/tracker.css";
import axios from "axios";
import jQuery from "jquery";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";
import Chart from "chart.js";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

class VacStatedata extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apptitle: this.props.apptitle,
      vacData: [],
      vacState: []
    };
  }

  componentDidMount = (e) => {
    //e.preventDefault();

    axios
      .get(
        "https://api.cowin.gov.in/api/v1/reports/v2/getPublicReports",
        this.state
      )
      .then((res) => {
        //console.log(res.data);
        if (res.data) {
          var Timestamp = res.data.timestamp;
          var date = new Date(Timestamp);
          var formattedDate =
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear();
          var formattedTime =
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
          jQuery("#Timestamp").html(formattedDate);
          jQuery("#datestamp").html(formattedTime);
          //console.log(formattedDate);
          var covidC = res.data.getBeneficiariesGroupBy;
          this.setState({ vacData: res.data });
          this.setState({ vacState: covidC });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    jQuery("#selectVacstate").change(function () {
      jQuery("#stateName").html(
        jQuery("option:selected", this).attr("data-state")
      );
      jQuery("#vacTotal").html(jQuery("option:selected", this).attr("total"));
      jQuery("#vacToday").html(jQuery("option:selected", this).attr("today"));
    });
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="row">
            <div className="col-12">
              <div className="updated-time-column">
                <p>
                  <i className="fa fa-bell"></i>&nbsp; Last Updated &nbsp;
                  <span id="Timestamp"></span> &nbsp;
                  <span id="datestamp"></span> HRS
                </p>
              </div>
            </div>

            <div className="col-12">
              <div className="details-column row">
                <div className="col-12">
                  <label> Choose State</label>
                  <select className="form-control" id="selectVacstate">
                    <option key="null" value="null">
                      - Select State
                    </option>
                    {this.state.vacState.map((vacStateN) => (
                      <option
                        key={vacStateN.state_id}
                        value={vacStateN.id}
                        data-state={vacStateN.state_name}
                        total={vacStateN.total}
                        partial_vaccinated={vacStateN.partial_vaccinated}
                        totally_vaccinated={vacStateN.totally_vaccinated}
                        today={vacStateN.today}
                      >
                        - {vacStateN.state_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12 stateTextColumn text-center">
                  <br />
                  <Link to="/vaccineIN">View India's Vaccination Data</Link>
                  <br />
                  <br />
                </div>
              </div>
              <div className="details-column row">
                <div className="col-12">
                  <p>
                    <strong>State Name: </strong>
                  </p>
                  <h2>
                    <strong>
                      <span id="stateName">****</span>
                    </strong>
                  </h2>
                </div>
              </div>

              <div className="details-column row">
                <div className="col-6">
                  <div className="col-inner green-col">
                    <p>
                      total <br /> <strong>Vaccinated </strong>
                    </p>

                    <h2>
                      <strong>
                        <span id="vacTotal">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
                <div className="col-6">
                  <div className="col-inner blue-col">
                    <p>
                      Today <br /> <strong>Vaccinated </strong>
                    </p>
                    <h2>
                      <strong>
                        <span id="vacToday">****</span>
                      </strong>
                    </h2>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default VacStatedata;
